export function getSelectableFileId(file) {
  return file?.id || file?._id || null;
}

export function toggleSelectAllFileIds(prev, files) {
  const allIds = (files || []).map(getSelectableFileId).filter(Boolean);
  if (allIds.length === 0) return prev;
  const everySelected = allIds.every((id) => prev.has(id));
  return everySelected ? new Set() : new Set(allIds);
}
